import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserDetail = _resolveComponent("UserDetail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UserDetail),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selectedAssistant)))
  ], 64))
}